import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "floating-cart-panel" }
const _hoisted_2 = { class: "floating-cart-header" }
const _hoisted_3 = { class: "floating-cart-title" }
const _hoisted_4 = { class: "floating-cart-items" }
const _hoisted_5 = { class: "floating-cart-item-row" }
const _hoisted_6 = { class: "floating-cart-item-name" }
const _hoisted_7 = ["lang"]
const _hoisted_8 = {
  key: 1,
  class: "floating-cart-item-qty"
}
const _hoisted_9 = {
  key: 0,
  class: "floating-cart-item-hint"
}
const _hoisted_10 = {
  key: 0,
  class: "floating-cart-more"
}
const _hoisted_11 = {
  key: 0,
  class: "floating-cart-totals"
}
const _hoisted_12 = {
  key: 0,
  class: "floating-cart-total"
}
const _hoisted_13 = {
  key: 1,
  class: "floating-cart-total"
}
const _hoisted_14 = {
  key: 1,
  class: "floating-cart-vat-note"
}
const _hoisted_15 = {
  class: "btn btn-primary floating-cart-cta",
  href: "/subscription"
}
const _hoisted_16 = { class: "floating-cart-vat-note" }
const _hoisted_17 = {
  key: 2,
  class: "floating-cart-vat-note"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.__("Your cart")), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visible_items, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "floating-cart-item",
          key: item.name
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(item.product_name || item.product_id), 1 /* TEXT */),
            (item.promotion_badge)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "eshop-promo-badge",
                  style: _normalizeStyle(item.promotion_badge.style),
                  lang: item.promotion_badge.title_lang || undefined
                }, _toDisplayString(item.promotion_badge.title), 13 /* TEXT, STYLE, PROPS */, _hoisted_7))
              : _createCommentVNode("v-if", true),
            (item.qty_in_basket > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "× " + _toDisplayString(item.qty_in_basket), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          (item.product_id === $setup.BOOST_PRODUCT_ID && !item.unpriced)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($setup.boost_price_hint(item)), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]))
      }), 128 /* KEYED_FRAGMENT */)),
      ($setup.hidden_item_count > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.__("+{0} more", [$setup.hidden_item_count])), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    _createCommentVNode(" Never shown next to the notice: totals over a partly priced cart would be wrong. "),
    (!$setup.notice && ($setup.cart.subscription_total_in_basket > 0 || $setup.cart.setup_total_in_basket > 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          ($setup.cart.subscription_total_in_basket > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString(_ctx.__("Monthly subscription")), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString($setup.ioi_format_currency($setup.cart.subscription_total_in_basket || 0.0, $setup.cart.currency)), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.cart.setup_total_in_basket > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("span", null, _toDisplayString(_ctx.__("One-off purchase")), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString($setup.ioi_format_currency($setup.cart.setup_total_in_basket || 0.0, $setup.cart.currency)), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.notice)
      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString($setup.notice), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.__("See selection")), 1 /* TEXT */),
    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.__("Prices exclude VAT")), 1 /* TEXT */),
    _createCommentVNode(" A basket with a variable price: its note opens the rules of those of its products\n\t\t     that have one (PriceRuleTrigger.vue), and is plain text when none has. "),
    ($setup.variable_lines.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
          _createVNode($setup["PriceRuleTrigger"], {
            rules: $setup.variable_rules,
            text: _ctx.__('contains variable price, see rules')
          }, null, 8 /* PROPS */, ["rules", "text"])
        ]))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */)), [
    [_vShow, $setup.has_items]
  ])
}